export default [{
    path: '/add-new-site',
    name: 'add-new-site',
    component: () =>
        import ('@/views/add-new-site/Index.vue'),
    meta: {
        pageTitle: 'Add New Site',
    },
}]